module.exports = __webpack_public_path__ + "static/img/customer1.e3fdd60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customer1.png
// module id = MRrF
// module chunks = 0